import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from '../../pages/sidebar/Sidebar';
import { VehicleWebSocketProvider } from "../utilities/VehicleWebSocketContext.jsx";
import './AppLayout.css';

const AppLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  return (
    <VehicleWebSocketProvider>
      <div className="app-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
        {isSidebarOpen && (
          <button
            className="sidebar-backdrop"
            onClick={() => setIsSidebarOpen(false)}
            aria-label="Close sidebar"
          />
        )}
        <div className={`main-shell ${isSidebarOpen ? "drawer-open" : ""}`}>
          <div className="content">
            <Outlet
              context={{
                openSidebar: () => setIsSidebarOpen(true),
              }}
            />
          </div>
        </div>
      </div>
    </VehicleWebSocketProvider>
  );
};

export default AppLayout;
